export default "__VITE_ASSET__CAnyJ$_Z__"